/* Quiet text button: no border until hovered or open, so it doesn't compete with the list */
.trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 8px 0 10px;
  border: 0;
  border-radius: var(--tuna-shape-radius-md);
  background: transparent;
  color: var(--tuna-palette-text-primary);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-fontSize-sm);
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.trigger:hover,
.trigger[data-popup-open] {
  background-color: var(--tuna-palette-action-selected);
}

.trigger:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.direction {
  color: var(--tuna-palette-text-secondary);
}

.menu {
  min-width: 220px;
  padding: 6px 0;
}

.hint {
  margin: 4px 16px 8px;
  max-width: 200px;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-fontSize-xs);
  line-height: 1.45;
  color: var(--tuna-palette-text-secondary);
}

@media (max-width: 599.95px) {
  .trigger {
    flex: none;
    height: 36px;
    background-color: var(--tuna-palette-action-selected);
  }

  /* No room for the direction on phones; the accessible name still carries it */
  .direction {
    display: none;
  }
}
